export interface SpecialEventColors {
  hybridGroup?: string;
  hybridIndividual?: string;
  hybridPlaceholder?: string;
  meetAndGreet?: string;
}

export const DEFAULT_SPECIAL_EVENT_COLORS: Required<SpecialEventColors> = {
  hybridGroup: '#96DAC9',
  hybridIndividual: '#FFAE9E',
  hybridPlaceholder: '#E8DDD0',
  meetAndGreet: '#4580E4',
};

// When true for a key, that event type uses the background color source (e.g. program level)
// instead of its custom special color.
export interface SpecialEventColorOverrides {
  hybridGroup?: boolean;
  hybridIndividual?: boolean;
  hybridPlaceholder?: boolean;
  meetAndGreet?: boolean;
}

export const DEFAULT_SPECIAL_EVENT_COLOR_OVERRIDES: Required<SpecialEventColorOverrides> = {
  hybridGroup: false,
  hybridIndividual: false,
  hybridPlaceholder: false,
  meetAndGreet: false,
};
